/**
 * Header component.
 * @module components/theme/Header/Header
 */

import React, { Component } from 'react';
import { Container, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Anontools,
  LanguageSelector,
  Logo,
  Navigation,
} from '@plone/volto/components';

/**
 * Header component class.
 * @class Header
 * @extends Component
 */
class Header extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    token: PropTypes.string,
    pathname: PropTypes.string.isRequired,
  };

  /**
   * Default properties.
   * @property {Object} defaultProps Default properties.
   * @static
   */
  static defaultProps = {
    token: null,
  };

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */

  render() {
    return (
      <div id="header">
        <div className="header-slim">
          <Container>
            <div className="header-content">
              <Link to="/chi-siamo">Chi siamo</Link>
              <Link to="/contatti">Contatti</Link>
              <Link to="/newsletter">Newsletter</Link>
            </div>
          </Container>
        </div>
        <Segment
          basic
          className="header-wrapper"
          role="banner"
          style={{ marginTop: 0 }}
        >
          <Container>
            <div className="header">
              <div className="logo-nav-wrapper">
                <div className="logo">
                  <Logo />
                </div>
              </div>
              <div className="header-navigation">
                <Navigation pathname={this.props.pathname} />
              </div>
            </div>
          </Container>
        </Segment>
      </div>
    );
  }
}

export default connect((state) => ({
  token: state.userSession.token,
}))(Header);
